import { NgStyle } from '@angular/common';
import {Component, computed, effect, input, OnDestroy, signal} from '@angular/core';

@Component({
  selector: 'app-user-code-timer',
  imports: [NgStyle],
  templateUrl: './user-code-timer.component.html',
  styleUrl: './user-code-timer.component.scss'
})
export class UserCodeTimerComponent implements OnDestroy {
  secondsLeft = input<number>(0);
  separator   = input<string>(':');
  startTimerFlag   = input<boolean>(false);
  fromUserCodePages   = input<boolean>(false);

  private remaining = signal(0);
  private timerId: any = null;

  private _react = effect(() => {
    const init = Math.max(0, Math.floor(this.secondsLeft() ?? 0));
    this.stopTimer();
    this.remaining.set(init);
    if (this.startTimerFlag() && init > 0) {
      this.startTimer();
    }
  });

  displaySeconds = computed(() => this.remaining());

  timeUnits = computed(() => {
    const total = this.displaySeconds();
    const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
    const minutes = Math.floor(total / 60);
    const seconds = total % 60;

    return [
      { value: pad(minutes), raw: minutes },
      { value: pad(seconds), raw: seconds }
    ];

  });

  private startTimer() {
    this.timerId = setInterval(() => {
      const next = Math.max(0, this.remaining() - 1);
      this.remaining.set(next);
      if (next === 0) this.stopTimer();
    }, 1000);
  }

  private stopTimer() {
    if (this.timerId) { clearInterval(this.timerId); this.timerId = null; }
  }

  ngOnDestroy() { this.stopTimer(); }
}
